module.exports = __webpack_public_path__ + "img/LUCKY_LIONS_01.9d7b0d41.jpg";